import type { DefaultOptions, FilteredValues } from '$saga/types/search.types';
/**
 * Takes a search query string and find all the options that match the query
 * return the list, if query string is empty then returns whole defaultOptions list
 * @param query
 * @param defaultOptions
 */
export const filterOptions = ({
    query,
    defaultOptions,
}: {
    query: string;
    defaultOptions: DefaultOptions;
}) => {
    if (!defaultOptions) return [];

    if (query === '') {
        return defaultOptions;
    }

    const normalizedSearchValue = query
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');

    const results: FilteredValues = [];

    for (const option of defaultOptions) {
        if (option.hidden) continue;

        const normalizedLabel = option.label
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');

        let score = 0;

        // Calculate match score
        if (normalizedLabel === normalizedSearchValue) {
            score = 100; // Exact match
        } else if (normalizedLabel.startsWith(normalizedSearchValue)) {
            score = 75; // Starts with
        } else if (normalizedLabel.includes(normalizedSearchValue)) {
            score = 50; // Contains
        } else {
            // Fuzzy match - check for sequential characters
            let searchIndex = 0;
            let lastMatchPos = -1;

            for (let i = 0; i < normalizedSearchValue.length; i++) {
                const char = normalizedSearchValue[i];
                const pos = normalizedLabel.indexOf(char, lastMatchPos + 1);

                if (pos !== -1) {
                    // Match found
                    searchIndex++;
                    lastMatchPos = pos;
                }
            }

            // If we matched at least 70% of characters
            if (searchIndex >= normalizedSearchValue.length * 0.8) {
                score = 25 + (searchIndex / normalizedSearchValue.length) * 25;
            }
        }

        if (score > 0) {
            results.push({
                ...option,
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                _score: score,
            });
        }
    }

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return results.sort((a, b) => (b._score || 0) - (a._score || 0));
};

export const setDepthPadding = (depth: number) => {
    switch (depth) {
        case 1:
            return 'pl-2xl';
        case 2:
            return 'pl-4xl';
        case 3:
            return 'pl-5xl';
        case 4:
            return 'pl-6xl';
        default:
            return 'pl-0';
    }
};
